export const booleanFieldMap = {
  ChainAccident: { 1: "Bəli", 0: "Xeyr" },
  HasPolice: { 1: "Bəli", 0: "Xeyr" },
  IsProperty: { 1: "Bəli", 0: "Xeyr" },
  Injured: { 1: "Bəli", 0: "Xeyr" },
  IsAnimal: { 1: "Bəli", 0: "Xeyr" },
  Fraud: { 1: "Var", 0: "Yoxdur" },
  Subragation: { 1: "Var", 0: "Yoxdur" },
  VinCheck: { 1: "Bəli", 0: "Xeyr" },
   NotSendService: { 1: "Bəli", 0: "Xeyr" },
};

export function transformBooleanField(key, value) {
  if (booleanFieldMap[key] && value in booleanFieldMap[key]) {
    return booleanFieldMap[key][value];
  }
  return value;
}
